import React, { Component } from 'react'
import Modal from 'react-modal';
import SimpleReactValidator from 'simple-react-validator';

import UploadPic from '../../assets/img/upload.svg';
import './ProgramFormRegistration.css';

const API_REGESTRATION = process.env.REACT_APP_API_REGESTRATION;
export default class ProgramFormRegistration extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: this.props.showModal,
      fullName: '',
      employer: '',
      position: '',
      experience: '',
      path: '',
      email: '',
      phone: '',
      resume: '',
      fileName: '',
      isSending: false,
      isRegisterd: false,
      messageForm: '',
      error: false,
    }
    this.validator = new SimpleReactValidator({
      validators: {
        name: {  // name the rule
          message: 'يرجى كتابة الاسم بشكل صحيح',
          rule: (val, params, validator) => {
            // regex to match name (only alphabet)
            return validator.helpers.testRegex(val, /^[\u0621-\u064Aaa-zA-Z]+(([',. -][\u0621-\u064Aaa-zA-Z ])?[\u0621-\u064Aaa-zA-Z]*)*$/) && params.indexOf(val) === -1
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
      },
      messages: {
        email: 'يرجى كتابة بريد إلكتروني صحيح.',
        phone: 'يرجى كتابة رقم الهاتف بشكل صحيح',
        default: '* هذا الحقل مطلوب'
      },
      // autoForceUpdate: this
    });
  }

  handelChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handelSubmitForm = (e) => {
    e.preventDefault();
    const { fullName, employer, position, experience, path, email, phone, resume } = this.state;
    if (this.validator.allValid() && position && experience && resume !== null) {
      this.setState({ isSending: true })
      try {
        this.setState({ isSending: true });
        fetch(API_REGESTRATION, {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            fullName,
            employer,
            position,
            experience,
            path,
            email,
            phone,
            resume
          })
        })
          .then(res => res.json())
          .then(res => this.showStatusMessage(res))
          .then(this.resetForm)
          .catch(err => console.log(err));
      } catch (err) {
        return (
          this.setState({
            messageForm: "فشل التسجيل, حاول مجددًا"
          }),
          setTimeout(() => {
            this.setState({
              messageForm: ""
            });
          }, 3000)
        );
      }
    }
    else {
      return (
        this.validator.showMessages(),
        this.setState({
          error: true,
          messageForm: "الرجاء التحقق من كافة الحقول"
        }),
        setTimeout(() => {
          this.setState({
            error: false,
            messageForm: ""
          });
        }, 5000)
      )
    }
  }

  handleFileInputChange = (e) => {
    const acceptedFiles = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/png', 'image/jpeg', 'image/jpg'];
    const file = e.target.files[0];
    if (acceptedFiles.some(type => type === file.type)) {
      this.setState({ fileName: file.name })
      this.getBase64(file);
    }
  }

  getBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.setState({ resume: reader.result })
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  showStatusMessage = res => {
    if (res.msg) {
      return this.setState(
        {
          isRegisterd: true,
          messageForm: "تم التسجيل",
          isSending: false
        },
        () => {
          setTimeout(() => {
            this.setState({
              isRegisterd: false,
              messageForm: ""
            });
            // close the model after registration been confirmed
            this.props.closeModal()
          }, 2500);
        }
      );

    } else {
      return this.setState(
        {
          messageForm: "فشل التسجيل, حاول مجددًا"
        },
        () => {
          setTimeout(() => {
            this.setState({
              messageForm: ""
            });
          }, 3000);
        }
      );
    }
  };

  resetForm = () => {
    this.setState({
      isSending: false,
      fullName: "",
      employer: "",
      position: "",
      experience: "",
      path: "",
      email: "",
      phone: "",
      resume: ""
    });
  };

  render() {
    const {
      fullName,
      employer,
      position,
      experience,
      path,
      email,
      phone,
      fileName } = this.state

    return (
      <div className="modal-form">
        <div className="container">
          <div className="columns is-centered">
            <div className="column  ">

              <Modal
                ariaHideApp={false}
                isOpen={this.props.parentState === this.props.id}
                // onAfterOpen={this.afterOpenModal}
                onRequestClose={this.props.closeModal}
                // style={customStyles}
                className="Modal"
                overlayClassName="modal-overlay"
              >
                <h3 className="title is-5 has-text-centered mt-4 secondry-color">أكمل تعبئة النموذج للتسجيل</h3>
                <div className="form mt-1">
                  <div className="field">
                    <label className="label"></label>
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        placeholder="الاسم الثلاثي"
                        name='fullName'
                        value={fullName}
                        onChange={(e) => this.handelChange(e)} />
                      {/* validator */}
                      {this.validator.message(
                        "name",
                        this.state.fullName,
                        "required|name",
                        { className: "validation-message-error" }
                      )}

                    </div>
                  </div>

                  <div className="field">
                    <label className="label"></label>
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        placeholder="جهة العمل"
                        name='employer'
                        value={employer}
                        onChange={(e) => this.handelChange(e)} />
                      {this.validator.message(
                        "",
                        this.state.employer,
                        "required|name",
                        { className: "validation-message-error" }
                      )}
                    </div>
                  </div>
                  <div className="field">
                    <label className="label"></label>
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        placeholder="المنصب"
                        name='position'
                        value={position}
                        onChange={(e) => this.handelChange(e)} />
                      {this.validator.message(
                        "",
                        this.state.position,
                        "required|name",
                        { className: "validation-message-error" }
                      )}
                    </div>
                  </div>

                  <div className="field">
                    <label className="label"> عدد سنوات الخبرة</label>
                    <div className="selection-field">
                      <div className="select">
                        <select id='experience' className="control" name="experience" placeholder="عدد سنوات الخبرة"
                          value={experience}
                          onChange={(e) => this.handelChange(e)}
                        >
                          <option value="" >اختر ...</option>
                          <option value="أقل من 5 سنوات">أقل من 5 سنوات</option>
                          <option value="من 5 إلى 7 سنوات">من 5 إلى 7 سنوات</option>
                          <option value="من 7 إلى 10 سنوات">من 7 إلى 10 سنوات</option>
                          <option value="أكثر من 10 سنوات">أكثر من 10 سنوات</option>
                        </select>
                        {this.validator.message(
                          "",
                          this.state.position,
                          "required",
                          { className: "validation-message-error" }
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="field">
                    <label className="label"> المسار المرشح له</label>
                    <div className="selection-field">
                      <div className="select">
                        <div className="control">
                          <select id='path' className="control" name="path" placeholder="عدد سنوات الخبرة"
                            value={path}
                            onChange={(e) => this.handelChange(e)}>
                            <option value="">اختر ...</option>
                            <option value="مسار قيادة الأعمال">مسار قيادة الأعمال</option>
                            <option value="مسار تقنية المعلومات">مسار تقنية المعلومات</option>
                            <option value="مسار الابتكار والتصميم">مسار الابتكار والتصميم</option>
                            <option value="مسار الاستشارات الرقمية">مسار الاستشارات الرقمية</option>
                          </select>
                          {this.validator.message(
                            "",
                            this.state.position,
                            "required",
                            { className: "validation-message-error" }
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="field">
                    <label className="label"></label>
                    <div className="control">
                      <input
                        className="input"
                        type="email"
                        placeholder="البريد الإلكتروني"
                        name='email'
                        value={email}
                        onChange={(e) => this.handelChange(e)} />
                      {this.validator.message(
                        "email",
                        this.state.email,
                        "required|email",
                        { className: "validation-message-error" }
                      )}
                    </div>
                  </div>

                  <div className="field">
                    <label className="label"></label>
                    <div className="control">
                      <input
                        className="input"
                        type="number"
                        placeholder="رقم الجوال"
                        name='phone'
                        value={phone}
                        onChange={(e) => this.handelChange(e)} />

                      {this.validator.message(
                        "phone",
                        this.state.phone,
                        "required|phone",
                        { className: "validation-message-error" }
                      )}
                    </div>
                  </div>

                  <div className="field">
                    <div className="control">
                      {/* <label className="label" htmlFor="resume"> ارفق السيرة الذاتية</label> */}
                      <input
                        // className="inputfile"
                        style={{ display: 'none' }}
                        type="file"
                        placeholder="ارفق السيرة الذاتية"
                        name="resume"
                        // id="file"
                        accept=".doc,.docx, .pdf, .png, .jpeg .jpg"
                        // value={this.state.resume}
                        onChange={(e) => this.handleFileInputChange(e)}
                        ref={fileInput => this.fileInput = fileInput}
                      />
                      {/* {console.log(resume)} */}
                      <div className='is-flex center-v flex-dir-mobile'>
                        <button
                          className="file-input-btn button has-text-centered"
                          onClick={() => this.fileInput.click()}
                        > ارفق السيرة الذاتية
                                        <img src={UploadPic} alt='upload' />
                        </button>
                        {fileName ?
                          <span className='mr-2 mt-1 mb-1'> {fileName}</span> : ''}

                      </div>
                      {this.validator.message(
                        "",
                        this.state.resume,
                        "required",
                        { className: "validation-message-error" }
                      )}
                    </div>
                    <span className='file-input-span mt-2'>  الامتدادات المسموح بها doc,docx, pdf, png, jpeg jpg </span>
                  </div>

                  <div className='mt-2'>

                    <button
                      className={`register-btn button has-text-centered ${this.state.isSending ? "is-loading" : ""}`}
                      onClick={(e) => this.handelSubmitForm(e)}
                    > تسجيل </button>

                    <button
                      className="close-btn button has-text-centered mr-2"
                      onClick={this.props.closeModal}
                    > اغلاق</button>
                  </div>

                </div>

                {this.state.isRegisterd ? (
                  <p className="notification is-primary">
                    {this.state.messageForm}
                  </p>
                ) : this.state.error && !this.state.isSending ? (
                  <p className="notification is-danger">
                    {this.state.messageForm}
                  </p>
                ) : this.state.isMessageSent && this.state.isSending ? (
                  <p className="notification is-danger">
                    {this.state.messageForm}
                  </p>
                ) : (
                        ""
                      )}
              </Modal>
            </div>
          </div>
        </div>
      </div>
    )
  }
}